import { createContext } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
export const AlertContext = /*#__PURE__*/createContext({
  store: FloatingAlertStore,
  addAlert: () => {},
  isInitialized: false
});